import { useEffect, useState } from "react";

export const useViewPortDetector = () => {
  const [currentViewPort, setCurrentViewPort] = useState("mobile");
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setCurrentViewPort((pre) =>
        window.innerWidth > 1140 ? "desktop" : "mobile"
      );
    };

    handleResize();
    setIsReady(true);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { currentViewPort, isReady };
};

export default function initViewportHeight() {
  let scrollY = 0;

  const setViewportHeight = () => {
    const vh = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;

    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // Add this: Lock scroll when keyboard is open
    const keyboardOpen = window.visualViewport
      ? window.visualViewport.height < window.innerHeight * 0.75
      : window.innerHeight < window.screen.height * 0.75;

    if (keyboardOpen) {
      // Lock the scroll position
      scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.height = `${vh}px`;
    } else {
      // Restore scroll position
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.height = "";
      window.scrollTo(0, scrollY);
    }
  };

  setViewportHeight();

  window.addEventListener("resize", setViewportHeight);
  window.addEventListener("orientationchange", setViewportHeight);

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", setViewportHeight);
    window.visualViewport.addEventListener("scroll", setViewportHeight);
  }

  window.addEventListener("focusin", () => {
    setTimeout(setViewportHeight, 300);
  });

  window.addEventListener("focusout", () => {
    setTimeout(setViewportHeight, 300);
  });

  return () => {
    // Cleanup - restore body styles
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.height = "";

    window.removeEventListener("resize", setViewportHeight);
    window.removeEventListener("orientationchange", setViewportHeight);
    window.removeEventListener("focusin", setViewportHeight);
    window.removeEventListener("focusout", setViewportHeight);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", setViewportHeight);
      window.visualViewport.removeEventListener("scroll", setViewportHeight);
    }
  };
}
